<div class="accept-regulations-container w-100 cursor-pointer">
  <div class="accept-container align-items-center justify-content-between" [ngClass]="{ 'disabled': disabled}">
    <div class="d-flex">
      <label
        class="checkboxContainer"
        [style.height]="size"
        [ngClass]="{ 'checked-checkbox': checkboxAccepted, 'checked-small-checkbox': checkboxAccepted && smallCheckbox}">
        <input [style.width]="size" [style.height]="size" type="checkbox" (change)="toggleCheckbox()" [checked]="checked" [disabled]="disabled" />
        <span
          [style.width]="size"
          [style.height]="size"
          class="global-checkbox global-transition"
          [ngClass]="{
                        'error': submitted && !checkboxAccepted && required,
                        'small-checkbox' : smallCheckbox,
                        'earnings_together': additionalClass === 'earnings_together',
                        'accepted-commisions': additionalClass === 'earnings_status_payment_waiting',
                        'withdrawal-commissions': additionalClass === 'earnings_status_to_payment',
                        'pending-commissions': additionalClass === 'earnings_status_wait',
                        'rejected-commissions': additionalClass === 'earnings_status_rejected',
                        'leads_together': additionalClass === 'leads_together',
                        'leads': additionalClass === 'leads',
                        'leads_status_payment_waiting': additionalClass === 'leads_status_payment_waiting',
                        'leads_status_rejected': additionalClass === 'leads_status_rejected',
                        'leads_status_wait': additionalClass === 'leads_status_wait',
                        'visits': additionalClass === 'visits',
                        'conversion': additionalClass === 'conversion',
                        'epc': additionalClass === 'epc',
                        'acceptance': additionalClass === 'acceptance'
                    }">
          <nb-icon class="checkIcon" icon="check" pack="icomoon" [style.lineHeight]="size" [style.fontSize]="checkBoxSize"> </nb-icon>
        </span>
      </label>
      <h5
        *ngIf="text"
        class="accept-text global-transition"
        (click)="toggleCheckbox()"
        [ngClass]="{'not-checked': uncheckedGray && !this.checkboxAccepted}"
        [style.paddingLeft]="paddingLeft"
        [style.fontSize]="fontSize"
        [style.fontWeight]="fontWeight"
        [style.color]="fontColor">
        {{ translateText ? ('view_translations.' + text | translate) : text }}
        <ng-content></ng-content>
      </h5>
      <div
        *ngIf="tooltipText"
        class="tooltip-button tool-tip info-tooltip"
        ngbTooltip="{{ 'view_translations.' + tooltipText | translate }}"
        container="body"
        placement="top-right"
        tooltipClass="my-configurations-tooltip">
        <nb-icon icon="info" pack="icomoon" class="info-icon"></nb-icon>
      </div>
    </div>
    <div class="icon-wrapper" [ngClass]="text ? text : ''" *ngIf="checkBoxIcon">
      <nb-icon *ngIf="checkBoxIcon" class="pointer global-transition additional-icon" (click)="toggleCheckbox()" [icon]="checkBoxIcon" pack="icomoon"></nb-icon>
    </div>
  </div>
  <div class="error-message" *ngIf="submitted && !checkboxAccepted && required">
    <small class="form-text text-danger"> {{ 'view_translations.this_field_is_required' | translate }} </small>
  </div>
</div>
